export default "__VITE_ASSET__ffe2f9da__"